// Netherlands border coordinates — 513 points from Natural Earth 10m admin-0
// Source: https://raw.githubusercontent.com/nvkelso/natural-earth-vector/master/geojson/ne_10m_admin_0_countries.geojson
// Generated by: scripts/generate-netherlands-border.mjs (Douglas-Peucker, epsilon=2.05e-3)
// Mainland outer ring + 7 offshore islands (Wadden + delta),
// each a closed [lng, lat] ring. Caribbean Netherlands excluded.
export const NETHERLANDS_COORDS: [number, number][] = [
  [7.1946, 53.245],
  [7.1985, 53.2006],
  [7.1954, 53.185],
  [7.1719, 53.1377],
  [7.1727, 53.1258],
  [7.1851, 53.1054],
  [7.1944, 53.0338],
  [7.1928, 52.998],
  [7.1836, 52.9661],
  [7.1619, 52.9326],
  [7.0799, 52.8544],
  [7.062, 52.824],
  [7.0533, 52.7906],
  [7.044, 52.6826],
  [7.0367, 52.6474],
  [7.0185, 52.626],
  [6.9677, 52.6367],
  [6.9184, 52.6322],
  [6.8654, 52.642],
  [6.7705, 52.641],
  [6.737, 52.6347],
  [6.7018, 52.6191],
  [6.7102, 52.6087],
  [6.7037, 52.5914],
  [6.704, 52.5831],
  [6.7438, 52.5597],
  [6.6883, 52.5426],
  [6.6717, 52.5417],
  [6.684, 52.526],
  [6.689, 52.4905],
  [6.6951, 52.4756],
  [6.7148, 52.4616],
  [6.7412, 52.4537],
  [6.8203, 52.4468],
  [6.872, 52.4347],
  [6.9002, 52.4319],
  [6.9515, 52.4375],
  [6.9733, 52.4514],
  [7.0342, 52.3908],
  [7.0482, 52.3651],
  [7.0398, 52.3286],
  [7.0125, 52.2849],
  [7.0119, 52.2666],
  [7.0207, 52.2453],
  [7.0291, 52.2358],
  [7.0263, 52.2306],
  [6.9819, 52.214],
  [6.9477, 52.1828],
  [6.9277, 52.1719],
  [6.8848, 52.1603],
  [6.8654, 52.1478],
  [6.8433, 52.12],
  [6.8307, 52.1129],
  [6.7659, 52.1084],
  [6.7499, 52.1029],
  [6.7329, 52.092],
  [6.7114, 52.0673],
  [6.6799, 52.0605],
  [6.673, 52.0501],
  [6.675, 52.0348],
  [6.7782, 52.0013],
  [6.8092, 51.9795],
  [6.8107, 51.9606],
  [6.7898, 51.9511],
  [6.767, 51.9255],
  [6.7438, 51.9083],
  [6.7167, 51.8993],
  [6.6282, 51.8975],
  [6.5286, 51.8764],
  [6.4794, 51.853],
  [6.4629, 51.8484],
  [6.4425, 51.8484],
  [6.3785, 51.8601],
  [6.3866, 51.8376],
  [6.3825, 51.8276],
  [6.345, 51.8211],
  [6.342, 51.8367],
  [6.3257, 51.8425],
  [6.2874, 51.8462],
  [6.2647, 51.8662],
  [6.2252, 51.8625],
  [6.1914, 51.8712],
  [6.1592, 51.8873],
  [6.127, 51.8967],
  [6.093, 51.8853],
  [6.1427, 51.8552],
  [6.1561, 51.8421],
  [6.084, 51.8537],
  [6.0433, 51.8469],
  [6.0082, 51.8326],
  [5.9481, 51.823],
  [5.9315, 51.8157],
  [5.928, 51.8067],
  [5.9508, 51.7959],
  [5.9641, 51.7766],
  [5.9624, 51.7564],
  [5.9401, 51.7426],
  [5.9393, 51.7319],
  [5.9783, 51.7298],
  [6.0121, 51.7159],
  [6.022, 51.7095],
  [6.0086, 51.6812],
  [6.0315, 51.663],
  [6.0992, 51.6445],
  [6.0821, 51.6078],
  [6.0865, 51.5955],
  [6.153, 51.5384],
  [6.1933, 51.5093],
  [6.2053, 51.4584],
  [6.1941, 51.4174],
  [6.1927, 51.399],
  [6.2078, 51.3877],
  [6.202, 51.3789],
  [6.1989, 51.357],
  [6.1936, 51.3445],
  [6.1836, 51.3357],
  [6.1478, 51.3182],
  [6.0965, 51.2588],
  [6.0652, 51.2316],
  [6.0566, 51.2117],
  [6.0537, 51.1894],
  [6.0608, 51.1709],
  [6.0843, 51.1627],
  [6.1341, 51.1842],
  [6.1571, 51.1793],
  [6.1263, 51.1646],
  [6.1473, 51.1523],
  [6.1324, 51.1398],
  [6.0754, 51.1204],
  [5.9829, 51.0747],
  [5.9695, 51.0649],
  [5.9503, 51.0395],
  [5.938, 51.0309],
  [5.9196, 51.0297],
  [5.8943, 51.0471],
  [5.8805, 51.0521],
  [5.8525, 51.0428],
  [5.8582, 51.0193],
  [5.8736, 50.9906],
  [5.8746, 50.9654],
  [5.9277, 50.9777],
  [5.9678, 50.971],
  [6.0037, 50.9737],
  [6.0058, 50.9685],
  [5.9958, 50.9518],
  [5.9999, 50.9294],
  [6.0311, 50.9147],
  [6.0637, 50.9075],
  [6.0546, 50.8915],
  [6.0631, 50.8709],
  [6.0628, 50.8629],
  [6.0567, 50.8527],
  [6.0456, 50.8442],
  [6.023, 50.8454],
  [6.0093, 50.8405],
  [6.0005, 50.8304],
  [6.0036, 50.8126],
  [5.9983, 50.8007],
  [5.984, 50.7922],
  [5.9688, 50.7946],
  [5.973, 50.7818],
  [5.9971, 50.7629],
  [5.9949, 50.7499],
  [5.9748, 50.7475],
  [5.9022, 50.749],
  [5.8799, 50.7535],
  [5.7932, 50.7521],
  [5.7625, 50.771],
  [5.7524, 50.7734],
  [5.7436, 50.7691],
  [5.7278, 50.7542],
  [5.7066, 50.7542],
  [5.6884, 50.7608],
  [5.6987, 50.7838],
  [5.7005, 50.7956],
  [5.6633, 50.8051],
  [5.6407, 50.815],
  [5.6245, 50.8303],
  [5.6223, 50.8527],
  [5.6945, 50.9037],
  [5.7224, 50.9117],
  [5.764, 50.9594],
  [5.7447, 50.9632],
  [5.7224, 50.9594],
  [5.7617, 50.9992],
  [5.7776, 51.0236],
  [5.764, 51.0352],
  [5.7715, 51.0581],
  [5.7796, 51.0613],
  [5.7913, 51.055],
  [5.7989, 51.0615],
  [5.8118, 51.0823],
  [5.8049, 51.0966],
  [5.8267, 51.0969],
  [5.846, 51.1034],
  [5.8232, 51.1187],
  [5.8264, 51.1302],
  [5.8405, 51.1389],
  [5.8291, 51.1565],
  [5.8121, 51.1573],
  [5.7814, 51.1524],
  [5.7681, 51.1595],
  [5.7472, 51.1776],
  [5.7308, 51.1838],
  [5.659, 51.1791],
  [5.625, 51.1969],
  [5.5684, 51.2077],
  [5.5455, 51.2199],
  [5.5423, 51.2427],
  [5.5352, 51.262],
  [5.5167, 51.2772],
  [5.4932, 51.2865],
  [5.4716, 51.2881],
  [5.4099, 51.2635],
  [5.3891, 51.2587],
  [5.2707, 51.2618],
  [5.233, 51.2559],
  [5.2154, 51.2587],
  [5.2149, 51.2943],
  [5.1973, 51.3083],
  [5.1402, 51.3074],
  [5.1229, 51.3134],
  [5.1026, 51.3507],
  [5.0681, 51.3745],
  [5.0617, 51.3843],
  [5.0653, 51.4059],
  [5.0764, 51.4219],
  [5.0799, 51.4385],
  [5.0603, 51.462],
  [5.0275, 51.4768],
  [5.0121, 51.4743],
  [5.0061, 51.4683],
  [4.9958, 51.4467],
  [4.9571, 51.411],
  [4.9319, 51.3956],
  [4.9103, 51.3919],
  [4.8533, 51.4061],
  [4.7833, 51.4076],
  [4.7621, 51.4134],
  [4.7678, 51.4254],
  [4.7791, 51.4264],
  [4.8227, 51.4137],
  [4.8154, 51.4311],
  [4.8261, 51.4606],
  [4.8239, 51.4756],
  [4.8136, 51.4841],
  [4.7787, 51.4954],
  [4.7642, 51.4962],
  [4.7312, 51.4856],
  [4.6539, 51.4262],
  [4.6301, 51.4182],
  [4.6146, 51.4176],
  [4.5827, 51.4226],
  [4.5406, 51.4201],
  [4.5215, 51.4286],
  [4.5234, 51.4384],
  [4.5318, 51.4509],
  [4.5332, 51.4676],
  [4.5252, 51.4759],
  [4.4831, 51.4743],
  [4.4294, 51.462],
  [4.3771, 51.4429],
  [4.3892, 51.4346],
  [4.3806, 51.4197],
  [4.3799, 51.4095],
  [4.4101, 51.3838],
  [4.4162, 51.374],
  [4.4112, 51.3567],
  [4.3922, 51.3504],
  [4.3456, 51.3523],
  [4.2901, 51.3688],
  [4.2611, 51.3694],
  [4.249, 51.3842],
  [4.2449, 51.4145],
  [4.2347, 51.419],
  [4.223, 51.4095],
  [4.201, 51.4053],
  [4.1111, 51.407],
  [4.0702, 51.419],
  [4.0151, 51.4489],
  [3.9988, 51.4531],
  [3.957, 51.4558],
  [3.9431, 51.4504],
  [3.9021, 51.4049],
  [3.8867, 51.3998],
  [3.8508, 51.3974],
  [3.8272, 51.3911],
  [3.8164, 51.3941],
  [3.7891, 51.4122],
  [3.7288, 51.4308],
  [3.6897, 51.4543],
  [3.674, 51.4554],
  [3.6326, 51.4457],
  [3.61, 51.4451],
  [3.5534, 51.4531],
  [3.5354, 51.4592],
  [3.4948, 51.5009],
  [3.4619, 51.519],
  [3.451, 51.5297],
  [3.447, 51.546],
  [3.4575, 51.5551],
  [3.5604, 51.5946],
  [3.8289, 51.6127],
  [3.8511, 51.6108],
  [3.8822, 51.5961],
  [3.8965, 51.5838],
  [3.9058, 51.5692],
  [3.8716, 51.5556],
  [3.8716, 51.5494],
  [3.9673, 51.5431],
  [4.0159, 51.5308],
  [4.0571, 51.5084],
  [4.0703, 51.4927],
  [4.09, 51.4582],
  [4.1048, 51.4457],
  [4.1288, 51.4414],
  [4.1808, 51.4459],
  [4.2005, 51.4395],
  [4.2202, 51.4435],
  [4.2528, 51.4425],
  [4.2832, 51.4477],
  [4.2967, 51.4705],
  [4.2886, 51.4921],
  [4.2678, 51.5083],
  [4.2398, 51.5185],
  [4.1947, 51.5236],
  [4.1533, 51.5351],
  [4.0913, 51.5351],
  [4.0672, 51.544],
  [3.9881, 51.5903],
  [4.0412, 51.606],
  [4.0677, 51.6107],
  [4.1572, 51.6079],
  [4.1834, 51.6029],
  [4.2073, 51.5903],
  [4.2026, 51.6091],
  [4.19, 51.6167],
  [4.136, 51.6204],
  [4.118, 51.6307],
  [4.113, 51.6394],
  [4.1096, 51.6623],
  [4.1126, 51.6708],
  [4.1257, 51.6796],
  [4.1429, 51.6841],
  [4.1769, 51.6859],
  [4.1411, 51.7039],
  [4.0715, 51.7172],
  [4.0571, 51.7303],
  [4.0508, 51.7635],
  [4.0339, 51.7842],
  [3.9815, 51.81],
  [3.9626, 51.8012],
  [3.9372, 51.7963],
  [3.9114, 51.7964],
  [3.8919, 51.793],
  [3.8882, 51.7889],
  [3.8716, 51.7883],
  [3.8623, 51.8161],
  [3.8914, 51.8283],
  [3.9541, 51.8402],
  [3.9627, 51.8474],
  [3.9822, 51.8483],
  [4.0156, 51.8436],
  [4.0476, 51.8337],
  [4.0654, 51.8371],
  [4.0776, 51.8436],
  [4.0446, 51.8745],
  [4.0321, 51.882],
  [4.0298, 51.8883],
  [4.032, 51.8961],
  [4.0435, 51.9087],
  [4.0402, 51.9241],
  [4.01, 51.9801],
  [4.0156, 51.9877],
  [4.0225, 51.9944],
  [4.069, 51.9879],
  [4.1077, 51.9919],
  [4.1419, 52.0056],
  [4.2847, 52.1129],
  [4.4069, 52.2235],
  [4.5081, 52.3364],
  [4.5686, 52.4453],
  [4.5773, 52.4809],
  [4.5969, 52.5066],
  [4.6393, 52.7007],
  [4.6571, 52.7502],
  [4.6694, 52.7966],
  [4.7117, 52.8631],
  [4.7214, 52.8959],
  [4.7264, 52.9383],
  [4.7339, 52.9589],
  [4.7455, 52.9676],
  [4.807, 52.9618],
  [4.8169, 52.9676],
  [4.8244, 52.9602],
  [4.8094, 52.9296],
  [4.8328, 52.9113],
  [4.8738, 52.904],
  [4.9131, 52.9056],
  [4.9358, 52.9134],
  [4.9783, 52.9357],
  [5.0389, 52.9435],
  [5.0781, 52.954],
  [5.3128, 53.0828],
  [5.3589, 53.0893],
  [5.3792, 53.0974],
  [5.3998, 53.1221],
  [5.4271, 53.1903],
  [5.4474, 53.2209],
  [5.5042, 53.257],
  [5.541, 53.2666],
  [5.5916, 53.3028],
  [5.6597, 53.312],
  [5.6946, 53.3301],
  [5.8547, 53.3688],
  [5.8908, 53.3843],
  [5.9137, 53.3854],
  [5.9808, 53.4061],
  [6.2739, 53.4127],
  [6.3115, 53.399],
  [6.3456, 53.4127],
  [6.4944, 53.4387],
  [6.7302, 53.4606],
  [6.8291, 53.4506],
  [6.8498, 53.4449],
  [6.8669, 53.4343],
  [6.9006, 53.3518],
  [6.93, 53.3401],
  [6.9486, 53.3261],
  [6.9802, 53.3198],
  [7.02, 53.3061],
  [7.0378, 53.3096],
  [7.0462, 53.3039],
  [7.0583, 53.3019],
  [7.0855, 53.3096],
  [7.0855, 53.3028],
  [7.0735, 53.2956],
  [7.0807, 53.2668],
  [7.1111, 53.2563],
  [7.1946, 53.245],
]

export const NETHERLANDS_ISLANDS: [number, number][][] = [
  [
    [3.3494, 51.3752],
    [3.5414, 51.4167],
    [3.834, 51.3432],
    [3.9841, 51.4105],
    [4.2215, 51.368],
    [4.119, 51.2724],
    [3.8087, 51.2053],
    [3.7762, 51.2545],
    [3.6095, 51.2904],
    [3.3917, 51.2468],
    [3.3494, 51.3752],
  ],
  [
    [4.0366, 51.6859],
    [4.0994, 51.6541],
    [3.978, 51.6233],
    [3.8093, 51.6995],
    [3.7654, 51.6784],
    [3.6867, 51.6927],
    [3.6895, 51.725],
    [3.8142, 51.7482],
    [3.9618, 51.7381],
    [4.0366, 51.6859],
  ],
  [
    [4.8926, 53.111],
    [4.9131, 53.1048],
    [4.8931, 53.0761],
    [4.7957, 53.0003],
    [4.7268, 53.0031],
    [4.7077, 53.0285],
    [4.7337, 53.0842],
    [4.8543, 53.1877],
    [4.8898, 53.1809],
    [4.9102, 53.1346],
    [4.8926, 53.111],
  ],
  [
    [5.4236, 53.4304],
    [5.5853, 53.4536],
    [5.562, 53.4343],
    [5.4754, 53.4269],
    [5.4817, 53.4127],
    [5.4686, 53.4085],
    [5.2083, 53.3527],
    [5.1799, 53.3531],
    [5.1677, 53.3682],
    [5.1789, 53.3854],
    [5.2502, 53.4064],
    [5.4236, 53.4304],
  ],
  [
    [5.674, 53.4679],
    [5.9138, 53.4739],
    [5.9546, 53.4611],
    [5.7528, 53.4474],
    [5.679, 53.4301],
    [5.6361, 53.4487],
    [5.6419, 53.4634],
    [5.674, 53.4679],
  ],
  [
    [6.2118, 53.5089],
    [6.3108, 53.5141],
    [6.3387, 53.5089],
    [6.3387, 53.502],
    [6.1532, 53.4688],
    [6.1333, 53.4536],
    [6.1271, 53.4631],
    [6.1333, 53.4679],
    [6.1228, 53.4816],
    [6.148, 53.4949],
    [6.2118, 53.5089],
  ],
  [
    [4.8789, 53.2209],
    [4.9212, 53.2537],
    [4.9865, 53.29],
    [5.0545, 53.3138],
    [5.1048, 53.3096],
    [5.1048, 53.3028],
    [5.0781, 53.3028],
    [5.0365, 53.2918],
    [4.9102, 53.2125],
    [4.8789, 53.2209],
  ],
]

/**
 * Coordinates for the Dutch cities the locations page can pin.
 *
 * Same shape and purpose as `GERMANY_MAJOR_CITIES`: the locations page matches
 * a CMS coming-soon city by `name` to find its pin position. Only the four
 * launch cities are listed, because a pin the page can't explain reads as a
 * location we have.
 *
 * Coordinates carried over from the hardcoded pre-launch NL map hero.
 */
export const NETHERLANDS_MAJOR_CITIES: Array<{
  name: string
  lat: number
  lng: number
  dy?: number
  dx?: number
}> = [
  { name: "Amsterdam", lat: 52.372, lng: 4.904 },
  { name: "Rotterdam", lat: 51.922, lng: 4.479 },
  { name: "Utrecht", lat: 52.091, lng: 5.122 },
  { name: "Den Haag", lat: 52.078, lng: 4.288 },
]
